import { ContainerSizes, PageContainer } from 'components';
import { ButtonColors, LinkButton } from 'components/DesignButton/DesignButton';
import { Typography } from '@repo/ui';
import TakeNoteSVG from 'assets/images/placeholders/take-note-01.svg';

interface NoKitResultsProps {
  hasOtherKitsWithResults?: boolean;
}

export const NoKitResults = ({
  hasOtherKitsWithResults = false,
}: NoKitResultsProps) => {
  return (
    <PageContainer
      size={ContainerSizes.AUTO}
      className='flex flex-column gap-2 text-center'
    >
      <div className='mt-4'>
        <img src={TakeNoteSVG} className='mx-auto' />
      </div>
      <Typography variant={'heading-l'}>No results yet</Typography>
      <Typography variant={'body-s'} serif className='grey-text'>
        {hasOtherKitsWithResults
          ? "Go to the Home page to see your kit's progress or change the dropdown to view previous results."
          : "Go to the Home page to see your kit's progress."}
      </Typography>
      <div className='flex justify-center mt-2'>
        <LinkButton href='/' label='Go to Home' variant='solid' size='medium' color={ButtonColors.PURPLE} />
      </div>
    </PageContainer>
  );
};
